import {useCallback, useEffect, useRef, useState} from 'react'

// Tracks which slide a scroll-snap carousel is on, derived from scroll position.
// Shared by the mobile carousel and the fullscreen modal track.
export default function useCarouselIndex(initialIndex = 0) {
  const [currentIndex, setCurrentIndex] = useState(initialIndex)
  const rafRef = useRef(null)

  const handleScroll = useCallback(e => {
    // Guard against queuing multiple frames on fast scroll events
    if (rafRef.current !== null) return
    const el = e.currentTarget
    rafRef.current = requestAnimationFrame(() => {
      setCurrentIndex(Math.round(el.scrollLeft / el.clientWidth))
      rafRef.current = null
    })
  }, [])

  useEffect(() => {
    return () => {
      if (rafRef.current !== null) cancelAnimationFrame(rafRef.current)
    }
  }, [])

  return {currentIndex, setCurrentIndex, handleScroll}
}
